
/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React from "react";
import { Container } from "react-bootstrap";
// import { QueryListProvider } from "../../../component/solution/QueryList/QueryListContext";
import { QueryListProvider } from "../../../component/solution/QueryTableList/QueryListContext";
import { QueryList } from "../../../component/solution/QueryList/QueryList";
import { CastType } from "../../../component/solution/Interfaces";
import { formatDateFull } from "../../../component/solution/utils/AppUtil";
import { QueryTableList } from "../../../component/solution/QueryTableList/QueryTableList";

export const SalesInvoice: React.FC = () => {

    return(
        <React.Fragment>
            {/* <Container fluid className="p-0">
                <QueryListProvider>
                    <QueryList
                        listTitle={"Sales Invoices"}
                        recordTitle={"Sales Invoice"}
                        tableName={"sa_sales_invoice"}
                        editTableName={"sa_purchase_invoice"}
                        editHasCompoundKey={false}
                        join={[]} 
                        select={[
                            {
                                fullColumnName: "customer_code",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "location",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "invoice_date",
                                aggregate: ""
                            },    
                            {
                                fullColumnName: "erp_invoice",
                                aggregate: ""
                            },                         
                            {
                                fullColumnName: "fixably_id",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "erp_updated",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "created",
                                aggregate: ""
                            },                            
                            {
                                fullColumnName: "updated",
                                aggregate: ""
                            }                            
                        ]}
                        where={[
                            // {
                            //     fullColumnName: "is_base_item",
                            //     value: false,
                            //     operator: "EQ",
                            //     cast: CastType.BOOLEAN
                            // }
                        ]} 
                        orderBy={[    
                            {
                                fullColumnName: "created",
                                direction: "DESC",
                                cast: CastType.STRING
                            }
                    ]} 
                        groupBy={[]}                   
                    />
                </QueryListProvider>
            </Container> */}

              <Container fluid className="p-0">
                <QueryListProvider>
                    <QueryTableList
                    listTitle={"Sales Invoices"}
                    recordTitle={"Sales Invoices"}
                    tableName={""}
                    editTableName={""}
                    hasIntegrationStatusLegend={false} 
                    errorCategoryName={''}
                    editHasCompoundKey={false}   
                    showFailedTransactionsTable={false}
                    query={{
                        appCode: null,
                        selectCode: null,
                        tableName: "sa_sales_invoice",
                        where: "",
                        orderBy: 'created DESC',
                        pageNum: 0,
                        pageSize: 100,
                        params: {},
                    }} 
                    orderColumns={[
                            { name: "customer_code", type: "STRING", sortable: true, searchable: true },
                            { name: "location", type: "STRING", sortable: true, searchable: true },
                            { name: "invoice_date", type: "TIMESTAMP", sortable: true, searchable: true },
                            { name: "erp_invoice", type: "STRING", sortable: true, searchable: true },
                            { name: "fixably_id", type: "INTEGER", sortable: true, searchable: true },
                            { name: "fixably_updated", type: "BOOLEAN", sortable: true, searchable: true },
                            { name: "created", type: "TIMESTAMP", sortable: true, searchable: false },
                            { name: "updated", type: "TIMESTAMP", sortable: true, searchable: false }
                    ]}
                    renderRowData={(row) => {

                        //console.log(row);
                                            
                        const tdStyle: React.CSSProperties = { whiteSpace: 'nowrap', border: '1px solid #deebed',  padding: '4px 8px', fontSize: '0.75rem' };
                        const tdEllipsis: React.CSSProperties = {...tdStyle, maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'};
                    
                        return (
                            <>
                                <td style={tdStyle} title={row.customer_code}>{row.customer_code}</td>
                                <td style={tdStyle} title={row.location}>{row.location}</td>
                                <td style={tdStyle} title={row.erp_invoice}>{row.erp_invoice}</td>
                                <td style={tdStyle} title={formatDateFull(String(row.invoice_date))}>{formatDateFull(String(row.invoice_date))}</td>
                                <td style={tdStyle} title={row.reference}>{row.reference}</td>
                                <td style={tdStyle} title={row.fixably_id}>{row.fixably_id}</td>
                                <td style={tdStyle} title={row.fixably_updated}>{row.fixably_updated}</td>
                                <td style={tdStyle} title={formatDateFull(String(row.created))}>{formatDateFull(String(row.created))}</td>
                                <td style={tdStyle} title={formatDateFull(String(row.updated))}>{formatDateFull(String(row.updated))}</td>
                            </>    
                        );
                    }}   
                    renderActions={(row) => {
                            return (
                                <td className="sa-record-control" style={{ border: '1px solid #deebed', height: '45px', fontSize: '0.55rem', padding: '0 5px'}}>
                    
                                </td>
                            );
                    }}                      
                />
                </QueryListProvider>
            </Container> 
        </React.Fragment>
    );
}


/* 
          "customer_code": "58493",
                "location": "CPTSC",
                "invoice_date": "2025-11-14T11:15:34+00:00",
                "erp_invoice": "2026104257",
                "fixably_id": 2956,
                "erp_updated"

*/